<template>
    <div class="right author-right">
      <div class="chapter-list">
        <div class="chapter-title flexible aItem-center jc-between">
          <div>
            <span @click="tabIndex = 1" class="f-csp font-MT f-fwb f20" :class="tabIndex == 1?'text-theme':'text-muted'">
              {{$lang('authorCenter.stories.Published')}}（{{publishedList.length}}）
              <i class="line" v-if="tabIndex == 1"></i>
            </span>
            <span @click="tabIndex = 2" class="f-csp font-MT f-fwb f20" :class="tabIndex == 2?'text-theme':'text-muted'">
              {{$lang('authorCenter.stories.Draft')}}（{{drafedList.length}}）
              <i class="line"  v-if="tabIndex == 2"></i>
            </span>
          </div>
          <img class="add-chapter-icon f-nto" v-if= "finishStatus" src="../../../assets/author/senLevel/ic_notadd.png"/>
          <img v-else class="add-chapter-icon f-csp" src="@/assets/author/senLevel/add.png" @click="goAdd(0, 'add')"/>
        </div>
        <div class="datanull" v-if="tabIndex == 2&&drafedList.length == 0 || tabIndex == 1&&publishedList.length == 0">
          <img src="@/assets/author/no-data.png"/>
          <p>{{$lang('authorCenter.stories.noChapter')}}</p>
        </div>
        <ul class="chapterlist clearfix" v-if="tabIndex == 1&&publishedList.length>0">
          <li class="f-csp flexible aItem-center font-MT f16" v-for="(chapter,index) in publishedList" @click="goAdd(chapter.id, 'edit')" >
            <span class="numIndex">{{index + 1}}</span>
            <span class="chapter-name flex ">{{chapter.iname}}</span>
            <i class="words">{{$lang('authorCenter.stories.words')}}:{{chapter.words}}</i>
            <span class="chapter-time">{{chapter.publishTime}}</span>
            <img src="@/assets/author/ic_time.png" v-if="chapter.timer" class="time-pub ml0">
          </li>
        </ul>
        <ul class="chapterlist clearfix" v-if="tabIndex == 2&&drafedList.length>0">
          <li class="f-csp flexible aItem-center font-MT f16" v-for="(chapter,index) in drafedList" @click="goAdd(chapter.id, 'edit')" >
            <span class="numIndex">{{index + 1}}</span>
            <span class="chapter-name flex">{{chapter.iname}}</span>
            <span class="words">{{chapter.words}}</span>
            <span class="chapter-time">{{chapter.updateTime}}</span>
          </li>
        </ul>
      </div>
      <addEmail ref="addEmail" v-if="ispopshow" :book="bookdetail" @closeEmail="closeEmail"></addEmail>
    </div>
</template>

<script>
import { getchapterlist,getNormalInfo } from "apiurl/author";
import baseURL from "@/api/env";
import addEmail from "@/components/author/addEmail";
export default {
  props: {
    booklist: Array,
    bookdetail: Object
  },
  components: {addEmail},
  watch: {
    bookdetail (n) {
      console.log(this.bookdetail)
      this.finishStatus = this.bookdetail.finished
    },
  },
  data () {
    return{
      imgURL: baseURL.IMG,
      chapterList: [],
      tabIndex: 1,
      publishedList: [],
      drafedList: [],
      finishStatus: true,
      ispopshow: false,
      book: {}
    }
  },
  mounted () {
    console.log(this.bookdetail)
    this.finishStatus = this.bookdetail.finished
    this.getChapterList()
  },
  methods: {
    getChapterList () {
      getchapterlist(this.$route.params.id).then(res=>{
        console.log(res)
        if (res.success) {
          if (res.data.length > 0) {
            this.publishedList = res.data[0].chapters.filter((item) => {
              return item.inspectStatus == 2
            })
            this.drafedList = res.data[0].chapters.filter((item) => {
              return item.inspectStatus == 0
            })
          }

        }
      })
    },
    goAdd (id, flag) {
      if (this.publishedList.length == 3 && flag == 'add') {
        this.getNormalInfoFun()
      } else {
        this.$router.push(`/authorManage/newChapter/${this.$route.params.id}/${id}/${this.bookdetail.allowPrice}`)
      }
    },
    async getNormalInfoFun () {
      let res = await getNormalInfo()
      console.log(res)
      if (res.success) {
        let info = res.data.authorDto
        if (info && info.email) {
          this.$router.push(`/authorManage/newChapter/${this.$route.params.id}/0/${this.bookdetail.allowPrice}`)
        } else {
          this.closeEmail(true)
        }
      }
    },
    closeEmail (data) {
      this.ispopshow = data
      this.$emit('changePop', data)
    },
  }
};
</script>

<style lang="scss" scoped>
  @import "@/styles/author.scss";
  .chapter-title{
    height: 90px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 16px 16px 0 0;
    >div{
      margin-left: 51px;
    }
    span{
      display: inline-block;
      height: 90px;
      line-height: 90px;
      position: relative;
      margin-right: 30px;
      i{
        display: block;
        width: 50px;
        height: 6px;
        background: #FF049B;
        position: absolute;
        border-radius: 3px;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    img{
      margin-right: 42px;
      width: 38px;
      height: 38px;
    }
  }
  .chapterlist{
    li{
      width: 100%;
      height: 60px;
      position: relative;
      color: #fff;
      &:nth-of-type(odd){
        background: #3A3A51;
      }
      &:nth-of-type(even){
        background: #2D2D3F;
      }
      &:hover{
        color: #FF049B!important;
        .words,.chapter-time{
          color: #FF049B!important;
        }
      }
      .numIndex{
        margin: 0 40px;
      }
      .time-pub{
        width: 30px;
        height: 30px;
        position: absolute;
        right: 15px;
      }
      .words{
        color: #8B8BA7;
      }
      .chapter-time{
        margin-right: 64px;
        margin-left: 15px;
        color: #8B8BA7;
      }
    }
  }
</style>
